module.exports = __webpack_public_path__ + "static/scrollbadge-73cd5ddfb21c593467db7eac76355dde.mp4";